<template>
  <span
    ref="triggerEl"
    class="inline-flex"
    @mouseenter="scheduleShow(triggerEl)"
    @mouseleave="hide"
    @focusin="showNow(triggerEl)"
    @focusout="hide"
    @click="hide"
  >
    <slot />
  </span>

  <TooltipBubble
    :visible="visible"
    :text="text"
    :bubble-style="bubbleStyle"
    :arrow-style="arrowStyle"
  />
</template>

<script setup>
import { ref } from 'vue'
import { useTooltip } from 'composables/useTooltip.js'
import TooltipBubble from 'controllers/vue_components/shared/TooltipBubble.vue'

const props = defineProps({
  text: { type: String, required: true },
  // Milliseconds of hover before it appears. See useTooltip.js.
  delay: { type: Number, default: 140 },
})

const triggerEl = ref(null)
const { visible, bubbleStyle, arrowStyle, showNow, scheduleShow, hide } = useTooltip({ delay: props.delay })
</script>
